import axiosInstance from "@/api/axiosInstance";

export async function adminCancelEnrollment(
  enrollmentId: number,
  reason: string,
): Promise<void> {
  await axiosInstance.post(
    `/api/private/admin/enrollments/${enrollmentId}/cancel`,
    { reason },
  );
}
